/**
 * @generated SignedSource<<d612d28888977b1ed0bb998a9c21ad1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectDetailsPersonRow_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_user" | "PlannerLeftColumn_user">;
  readonly " $fragmentType": "ProjectDetailsPersonRow_user";
};
export type ProjectDetailsPersonRow_user$key = {
  readonly " $data"?: ProjectDetailsPersonRow_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectDetailsPersonRow_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectDetailsPersonRow_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlannerLeftColumn_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanel_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "eec61e502b3850071dff25bb8e8d650b";

export default node;
